






import { Alert } from "@/types/alert";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class AlertRemove extends Vue {
  @Prop({ required: true })
  alert!: Alert;

  @Prop({ required: false, default: false })
  isDisabled!: boolean;

  title = "Remove alert";

  removeAlert() {
    if (window.confirm("Clicking OK will remove this alert from your cache. Are you sure you want to do this?")) {
      this.$ga.button(this.title);
      this.$store.dispatch("alerts/remove", this.alert);
    }
  }
}
